import React, { useEffect, useRef } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BrandContext } from "../../App";

import { useAuth } from "../../contexts/AuthContext";

const TranscriptDisplay = ({ transcript, scenarioData }) => {
  const theme = useTheme();
  const endRef = useRef(null);
  const { loggedInUser } = useAuth();
  console.log(scenarioData);

  useEffect(() => {
    if (endRef.current && endRef.current.parentNode) {
      const parent = endRef.current.parentNode;
      parent.scrollTop = parent.scrollHeight;
    }
  }, [transcript]);

  if (transcript == null) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          padding: theme.customSpacing["3xl"],
        }}
      >
        <CircularProgress />
        <Typography sx={{ ml: 2, color: theme.palette.text.brand_primary }}>
          Loading transcript...
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: `${theme.customSpacing["3xl"]} 0`,
        backgroundColor: "#transparent",
        overflowY: "auto",
      }}
    >
      {transcript.map(({ id, message, ai_generated, is_user }) => {
        const author = ai_generated || !is_user
          ? scenarioData?.avatar_persona?.name
          : loggedInUser?.first_name || "User";
        return (
          <Box
            key={id || message}
            sx={{ marginBottom: theme.customSpacing.lg }}
          >
            <Typography
              sx={{
                fontWeight: theme.typography.fontWeightRegular,
                color:
                  scenarioData?.avatar_persona?.avatar_model === author
                    ? theme.palette.background.button_primary_hover
                    : theme.palette.border.brand,
              }}
            >
              {author ?? "Avatar"}
            </Typography>
            <Typography
              sx={{
                color: theme.palette.text.brand_primary,
                fontWeight: theme.typography.fontWeightLight,
                fontSize: theme.typography.textSM.fontSize,
                lineHeight: theme.typography.textSM.lineHeight,
              }}
            >
              {message}
            </Typography>
          </Box>
        );
      })}
      <div ref={endRef} />
    </Box>
  );
};

export default TranscriptDisplay;
